<template>
  <section class="section wardrobe-section">
    <b-row>
      <b-col sm="12" lg="6" class="wardrobe-text-wrapper">
        <h2 class="display-4 mb-5">Experiment with your wardrobe</h2>
        <ul class="list-unstyled">
          <li class="d-flex mb-4">
            <i class="pe-3x pe-7s-news-paper accent mr-5"></i>
            <span class="align-self-center features-list-single">
              Add items to build your wardrobe
            </span>
          </li>
          <li class="d-flex mb-4">
            <i class="pe-3x pe-7s-scissors accent mr-5"></i>
            <span class="align-self-center features-list-single">
              Curate outfits using your own clothes
            </span>
          </li>
          <li class="d-flex">
            <i class="pe-3x pe-7s-users accent mr-5"></i>
            <span class="align-self-center features-list-single">
              See what others have added to their wardrobe
            </span>
          </li>
        </ul>
      </b-col>

      <b-col sm="12" offset-lg="1" lg="5">
        <browser data-aos="fade-right">
          <img
            slot="content"
            src="@/assets/img/features/wardrobe-sm.png"
            alt=""
            class="img-fluid"
          />
        </browser>
      </b-col>
    </b-row>
  </section>
</template>

<script>
import Browser from "@/components/landing/Browser.vue";

export default {
  components: {
    Browser
  }
};
</script>

<style lang="scss" scoped>
@import "~@/styles/_breakpoints.scss";
@import "~@/styles/_colour-palette.scss";

.wardrobe-section {
  margin-top: 100px;
  margin-bottom: 160px;

  @include for-tablet-landscape-up {
    margin-top: 160px;
  }

  .display-4 {
    font-weight: 300;
    font-size: 3rem;
  }

  .accent {
    color: $primary-accent;
  }

  .features-list-single {
    font-size: 18px;
  }

  .wardrobe-text-wrapper {
    margin-bottom: 100px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/landing/WardrobeSection.vue